import React from 'react';
import { isAdminOnlyDoc } from '../../../../../../../../utils/docTags';
import {
  resolveAttachedDocTitle,
  resolveAttachedDocIcon,
  isAttachedDocPermanentlyGone,
  isAttachedDocNamePending,
  formatPermanentlyDeletedLabel,
} from '../../../../../../../../utils/attachedDocUtils';
import AttachedDocMark from './AttachedDocMark';

/**
 * List of docs attached to the mission, with open / detach actions.
 */
const AttachedDocsList = ({
  visibleAttached,
  docsById,
  libraryLoading,
  onOpenDoc,
  onDetach,
}) => (
  <div className="mfv-attached-docs__list">
    {visibleAttached.map((entry, index) => {
      const meta = docsById.get(entry.docId);
      const loadingMeta = isAttachedDocNamePending(entry, meta, libraryLoading);
      const inBin = !!meta?.deletedAt;
      const permanentlyGone = isAttachedDocPermanentlyGone(
        entry,
        meta,
        libraryLoading
      );
      const rowTitle = permanentlyGone
        ? formatPermanentlyDeletedLabel(entry, meta)
        : resolveAttachedDocTitle(entry, meta);
      const rowIcon = resolveAttachedDocIcon(entry, meta);
      return (
        <div key={entry.docId} className="mfv-attached-docs__row">
          <button
            type="button"
            className={`mfv-attached-docs__row-main${
              permanentlyGone ? ' mfv-attached-docs__row-main--gone' : ''
            }${inBin ? ' mfv-attached-docs__row-main--in-bin' : ''}${
              loadingMeta ? ' mfv-attached-docs__row-main--loading' : ''
            }`}
            onClick={() => !loadingMeta && !permanentlyGone && !inBin && onOpenDoc(entry.docId)}
            disabled={loadingMeta || permanentlyGone || inBin}
            title={
              loadingMeta
                ? 'Loading doc…'
                : inBin
                  ? 'This doc is in the bin — restore it from Trash to open'
                  : permanentlyGone
                    ? 'This doc was permanently deleted'
                    : 'Open doc'
            }
          >
            <span className="mfv-attached-docs__row-icon">
              {loadingMeta ? (
                <span
                  className="mfv-attached-docs__icon-ph mfv-attached-docs__shimmer"
                  aria-hidden="true"
                />
              ) : (
                <AttachedDocMark icon={rowIcon} size={18} />
              )}
            </span>
            <span className="mfv-attached-docs__row-title">
              {loadingMeta ? (
                <span
                  className="mfv-attached-docs__title-ph mfv-attached-docs__shimmer"
                  style={{ width: `${48 + (index % 3) * 14}%` }}
                  aria-hidden="true"
                />
              ) : (
                rowTitle
              )}
            </span>
            {inBin && (
              <span className="mfv-attached-docs__badge mfv-attached-docs__badge--in-bin">
                In bin
              </span>
            )}
            {meta && !inBin && isAdminOnlyDoc(meta) && (
              <span className="mfv-attached-docs__badge">Admin</span>
            )}
          </button>
          <button
            type="button"
            className="mfv-attached-docs__detach"
            onClick={() => onDetach(entry.docId)}
            title={
              permanentlyGone
                ? 'Dismiss'
                : 'Detach from this mission (the doc stays in the library)'
            }
            aria-label={permanentlyGone ? 'Dismiss deleted doc' : 'Detach doc'}
          >
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>
      );
    })}
  </div>
);

export default AttachedDocsList;
